(function () {
  if (window.__brandStorySliderReady) return;
  window.__brandStorySliderReady = true;

  function init(root) {
    if (!root || root.dataset.brandStoryInitialized === 'true') return;

    var slides = Array.from(root.querySelectorAll('[data-slide]'));
    var prevButtons = Array.from(root.querySelectorAll('[data-prev]'));
    var nextButtons = Array.from(root.querySelectorAll('[data-next]'));
    var progress = root.querySelector('[data-progress]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var delay = Number(root.getAttribute('data-autoplay-speed')) || 5000;
    var current = 0;
    var timer = null;
    var isAnimating = false;

    root.dataset.brandStoryInitialized = 'true';

    if (slides.length <= 1) {
      prevButtons.forEach(function (btn) { btn.style.display = 'none'; });
      nextButtons.forEach(function (btn) { btn.style.display = 'none'; });
      if (progress) progress.style.width = '100%';
      return;
    }

    function updateProgress() {
      if (!progress) return;
      progress.style.width = ((current + 1) / slides.length) * 100 + '%';
    }

    function goTo(index) {
      if (isAnimating) return;
      isAnimating = true;

      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      updateProgress();

      window.setTimeout(function () {
        isAnimating = false;
      }, 620);
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || slides.length < 2) return;
      timer = setInterval(next, delay);
    }

    prevButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    });

    nextButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    var startX = 0;
    var deltaX = 0;

    root.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      deltaX = 0;
    }, { passive: true });

    root.addEventListener('touchmove', function (event) {
      deltaX = event.touches[0].clientX - startX;
    }, { passive: true });

    root.addEventListener('touchend', function () {
      if (Math.abs(deltaX) > 50) {
        if (deltaX < 0) next();
        else prev();
        startAutoplay();
      }
    });

    updateProgress();
    startAutoplay();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-brand-story-slider]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
